import { createContext, useContext } from 'react';
import type { ChecklistItemCtxValue } from '../types';

/** Read-only context exposed to an item's body via {@link useChecklistItemCtx}. */
export const ChecklistItemContext = createContext<ChecklistItemCtxValue | null>(null);

export function useChecklistItemCtx(): ChecklistItemCtxValue {
  const ctx = useContext(ChecklistItemContext);
  if (!ctx) {
    throw new Error('useChecklistItemCtx must be used within a <Checklist.Item>');
  }
  return ctx;
}

/**
 * Skip control for the current item, for a "Skip" affordance in an item's body. `skip()` marks a
 * pending step done (clock badge) and unlocks the next; `unskip()` returns it to pending. Persisted
 * across reloads when the {@link Checklist} has a `storageKey`.
 */
export function useSkipStep(): Pick<ChecklistItemCtxValue, 'isSkipped' | 'skip' | 'unskip'> {
  const { isSkipped, skip, unskip } = useChecklistItemCtx();
  return { isSkipped, skip, unskip };
}
